import { AbstractControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';

export abstract class FormUtils {
  isFieldInvalid(form: UntypedFormGroup, field: string, errorCode?: string): boolean {
    const control = form.get(field);
    if (!!control && control.touched) {
      if (!errorCode) {
        return control.invalid;
      }
      return control.hasError(errorCode);
    }
    return false;
  }

  getErrorMessage(form: UntypedFormGroup, field: string, errorCode: string): string {
    const error = this.getError(form, field, errorCode);
    return error ? error.message : '';
  }

  getFirstErrorMessage(form: UntypedFormGroup, controlName: string, defaultError: string = 'invalid'): string {
    if (!this.hasError(form, controlName)) {
      return '';
    }

    const control = form.get(controlName);
    const errors = control?.errors;

    const firstErrorKey = errors ? Object.keys(errors)[0] : null;

    return firstErrorKey ? `${controlName}.${firstErrorKey}` : `${controlName}.${defaultError}`;
  }

  hasError(form: UntypedFormGroup, controlName: string): boolean {
    const control = form.get(controlName);
    return !!(control?.touched && control?.invalid);
  }

  getError(form: UntypedFormGroup, field: string, errorCode: string) {
    return errorCode && form.controls[field] && form.controls[field].hasError(errorCode)
      ? form.controls[field].getError(errorCode)
      : null;
  }

  // TODO: (martin) this will be added in Angular 8 see: https://github.com/angular/angular/pull/26812
  markAllAsTouched(control: AbstractControl) {
    if (control instanceof UntypedFormControl) {
      control.markAsTouched({ onlySelf: true });
    } else if (control instanceof UntypedFormGroup) {
      this.markFormGroupAsTouched(control);
    } else if (control instanceof UntypedFormArray) {
      this.markFormArrayAsTouched(control);
    }
  }

  markFormGroupAsTouched(formGroup: UntypedFormGroup) {
    formGroup.markAsTouched({ onlySelf: true });

    Object.keys(formGroup.controls).forEach((field) => {
      const control = formGroup.get(field);
      if (control) {
        this.markAllAsTouched(control);
      }
    });
  }

  markFormArrayAsTouched(formArray: UntypedFormArray) {
    formArray.controls.forEach((arrayElement) => {
      this.markAllAsTouched(arrayElement);
    });
  }
}
